import { render } from "./Log1nTalentList.vue?vue&type=template&id=b5452b96&scoped=true&ts=true&lang=pug"
import script from "./Log1nTalentList.vue?vue&type=script&lang=ts"
export * from "./Log1nTalentList.vue?vue&type=script&lang=ts"

import "./Log1nTalentList.vue?vue&type=style&index=0&id=b5452b96&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5452b96"]])

export default __exports__